export const all = () => {
    return [
        {
            key: "ROLE_EMPLOYMENT",
            labelRef: 'EMPLOYEE',
        },
        {
            key: 'ROLE_SINGLE_WINDOW',
            labelRef: 'SINGLE_WINDOW',
        },
        {
            key: 'ROLE_ACCOUNTANT',
            labelRef: 'ACCOUNTANT',
        },
        {
            key: 'ROLE_DIRECTOR',
            labelRef: 'DIRECTOR',
        },
        {
            key: 'ROLE_LAWYER',
            labelRef: 'LAWYER',
        },
    ]
}

export const getLabelRefByKey = (value) => {
    return all().find(item => item.key === value)?.labelRef
}

export default {
    all,
    getLabelRefByKey,
}